

































import {Vue, Component, Prop} from 'vue-property-decorator';
import PortalInput from "@/components/common/PortalInput.vue";
import {ServiceDTO, UpdateServicePayload} from "@/components/payroll/business/services/ServiceDTO";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import Application from "@/state/Application";
import ServiceOrchestrator from "@/services/ServiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";

export type Mode = "view" | "edit"

@Component({
	components: {ServiceView, PortalInput}
})
export default class ServiceItem extends Vue {
	private mode: Mode = "view";

	private req: UpdateServicePayload = new UpdateServicePayload();

	@Prop()
	private service!: ServiceDTO

	toEdit() {
		this.req = new UpdateServicePayload(
			{
				serviceId: this.service.id,
				holderId: this.$wss.getCurrent.id,
				name: this.service.name,
				description: this.service.description,
				price: this.service.price * 100
			}
		)
		this.mode = "edit";
	}

	save() {
		Application.startLoading()
		ServiceOrchestrator.updateService(this.req).then(
			() => {
				this.service.name = this.req.name!
				this.service.price = this.req.price!
				this.mode = "view"
				Application.stopLoading()
			},
			err => processError(err, this)
		)
	}

	showDisableModal() {
		this.$modal.show(
			DeleteConfirmation,
			{
				targetName: "service",
				operationName: "disable",
				onDelete: this.disable
			}
		)
	}

	disable() {
		Application.startLoading()
		ServiceOrchestrator.disableService(this.service.id, this.service.holder.id!).then(
			() => {
				Application.stopLoading()
				this.mode = "view"

				this.service.active = false
			},
			err => processError(err, this)
		)
	}
}
